import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import styles from "./EmailCaptureBlock.module.scss";
import { EmailInput } from "../../Input/EmailInput/EmailInput";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EmailCaptureBlock = function EmailCaptureBlock(_ref) {
  var body = _ref.body,
    disclaimer = _ref.disclaimer,
    email = _ref.email,
    headline = _ref.headline,
    image = _ref.image;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image,
      style: {
        backgroundImage: "url(".concat(image, ")")
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(HeadingText, {
        className: styles.headline,
        align: "left",
        ariaLevel: 2,
        typog: "headline4",
        children: headline
      }), /*#__PURE__*/_jsx(Text, {
        className: styles.body,
        typog: "bodycopyLarge",
        children: body
      }), email !== null && email !== void 0 && email.success ? /*#__PURE__*/_jsx(Text, {
        className: styles.success,
        typog: "bodycopyLarge",
        children: email.successMessage
      }) : /*#__PURE__*/_jsx(EmailInput, _objectSpread({
        className: styles.input
      }, email)), /*#__PURE__*/_jsx(Text, {
        className: styles.disclaimer,
        typog: "captionSmall",
        richText: true,
        children: disclaimer
      })]
    })]
  });
};